/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { Container, Row } from '../../../styles/Grid';
import OffsetColumn from '../../ui/OffsetColumn';
import { OffsetConsumer } from '../../../contexts/OffsetContext';
import { GridConfig } from '../../../styles/Grid/GridSizes';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerMarginCss,
  containerPaddingCss,
  textParentCss,
} from './index.styles';

const defaultData = {
  Text: {
    value: '',
  },
  CenterAlignment: {
    value: false,
  },
  BackgroundColor: {
    id: '',
    url: '',
    fields: {
      Value: {
        value: '',
      },
    },
  },
};

const lgAndUpNotCenterAligned = 9;
const lgAndUpCenterAligned = 10;

const centerOffset = (columns, offsetLeft) => {
  let space = lgAndUpNotCenterAligned;
  if (!offsetLeft) {
    space = lgAndUpCenterAligned;
  }
  return (columns - offsetLeft - space) / 2;
};

export class HighlightText extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);
    const isCenterAligned = fields.CenterAlignment.value;
    return (
      <Spacer
        backgroundColor={fields.BackgroundColor}
        marginCss={containerMarginCss}
        paddingCss={containerPaddingCss}
      >
        <Container>
          <Row>
            <OffsetConsumer>
              {({ offsetLeft }) => {
                const centerAndOffsetValidation =
                  isCenterAligned && !offsetLeft;
                return (
                  <OffsetColumn
                    cols={{
                      sm: 6,
                      md: 8,
                      lg: centerAndOffsetValidation
                        ? lgAndUpCenterAligned
                        : lgAndUpNotCenterAligned,
                      xl: centerAndOffsetValidation
                        ? lgAndUpCenterAligned
                        : lgAndUpNotCenterAligned,
                    }}
                    offsets={{
                      lg: centerAndOffsetValidation
                        ? centerOffset(GridConfig.lg.columns, offsetLeft)
                        : 0,
                      xl: centerAndOffsetValidation
                        ? centerOffset(GridConfig.xl.columns, offsetLeft)
                        : 0,
                    }}
                  >
                    <h2 css={textParentCss(isCenterAligned)}>
                      <Text field={fields.Text} />
                    </h2>
                  </OffsetColumn>
                );
              }}
            </OffsetConsumer>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

HighlightText.displayName = 'HighlightText';

HighlightText.propTypes = {
  fields: PropTypes.shape({
    BackgroundColor: PropTypes.shape({
      value: PropTypes.string,
    }),
    Text: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default HighlightText;
